import { render, staticRenderFns } from "./DownloadedMultimediaComponent.vue?vue&type=template&id=6bce1bf2"
import script from "./DownloadedMultimediaComponent.vue?vue&type=script&lang=js"
export * from "./DownloadedMultimediaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports